import { reactToCwp } from '../../../common/react-utils'
import Advisor from './Advisor'

export default reactToCwp(Advisor)